import { render, staticRenderFns } from "./view.html?vue&type=template&id=bfa6ef20&scoped=true&"
import script from "./script.js?vue&type=script&lang=js&"
export * from "./script.js?vue&type=script&lang=js&"
import style0 from "./style.less?vue&type=style&index=0&id=bfa6ef20&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfa6ef20",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bfa6ef20')) {
      api.createRecord('bfa6ef20', component.options)
    } else {
      api.reload('bfa6ef20', component.options)
    }
    module.hot.accept("./view.html?vue&type=template&id=bfa6ef20&scoped=true&", function () {
      api.rerender('bfa6ef20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/modal/modal_container/index.vue"
export default component.exports